import { useTranslation } from 'react-i18next';

import { Typography } from '@speeki/global-ui-components';

import {
    MobileModal,
    MobileModalProps,
} from '@components/organisms/MobileModal/MobileModal';

import { useTenantByUuid } from '@utils/hooks/useTenantByUuid';

import { AuthService } from '@services/AuthService/AuthService';

import { CompanyPoliciesMobile } from '@domains/dashboard/organisms/CompanyPolicies/CompanyPolicies.mobile';

interface MobileCompanyPoliciesModalProps
    extends Pick<MobileModalProps, 'onClose' | 'open'> {}

export const MobileCompanyPoliciesModal = ({
    onClose,
    open,
}: MobileCompanyPoliciesModalProps) => {
    const { t } = useTranslation();

    const tenantUuid = AuthService.getTenantUuid();

    const { data } = useTenantByUuid({
        skip: !tenantUuid,
        variables: {
            uuid: tenantUuid ?? '',
        },
    });
    const policiesContent = data?.tenant?.policiesContent;

    return (
        <MobileModal onClose={onClose} open={open} topPadding={54}>
            <MobileModal.Container>
                <Typography.TextH3_24_34>
                    {t('MY_POLICIES_TEXT')}
                </Typography.TextH3_24_34>
                <CompanyPoliciesMobile content={policiesContent ?? ''} />
            </MobileModal.Container>
        </MobileModal>
    );
};
